import React from 'react';
import { StoreSetupChart, StoreSetupSearch } from '../../types/storeSetup.types';
import { SetupBeat } from './setupDraft';
import { setupCount, setupOn } from './setupPreviewModel';

const CHART_KIND: Record<string, string> = {
  donut: 'Anneau',
  bar_horizontal: 'Barres',
  bar_vertical: 'Barres',
  line: 'Courbe',
  gauge: 'Jauge'
};

const FIELD_KIND: Record<string, string> = {
  status: 'statut',
  delivery_status: 'livraison',
  total_amount: 'montant',
  created_at: 'date'
};

type Props = {
  searches: StoreSetupSearch[];
  charts: StoreSetupChart[];
  beat: SetupBeat | null;
};

function ChartGlyph({ type }: { type: string }) {
  if (type === 'line') {
    return (
      <svg className="setup-chart__line" viewBox="0 0 80 36" aria-hidden="true">
        <polyline points="2,28 18,22 32,24 48,12 64,16 78,6" />
      </svg>
    );
  }
  if (type === 'gauge') {
    return <span className="setup-chart__gauge" aria-hidden="true" />;
  }
  if (type === 'bar_horizontal') {
    return (
      <span className="setup-chart__hbars" aria-hidden="true">
        <i /><i /><i />
      </span>
    );
  }
  if (type === 'bar_vertical' || type === 'bar') {
    return (
      <span className="setup-chart__bars" aria-hidden="true">
        <i /><i /><i /><i />
      </span>
    );
  }
  return <span className="setup-chart__donut" aria-hidden="true" />;
}

const SetupBoard: React.FC<Props> = ({ searches, charts, beat }) => {
  const tiles = searches.filter((item) => item.dashboard);

  return (
    <div className="setup-board">
      <section aria-label="Recherches du tableau">
        <h3>Recherches</h3>
        {tiles.length ? (
          <div className="setup-board__tiles">
            {tiles.map((item) => (
              <article
                key={item.id}
                data-setup-id={item.id}
                className={`setup-tile${setupOn(item.id, beat)}`}
              >
                <strong>{setupCount(item.name)}</strong>
                <span>{item.name}</span>
                <em>{item.detail}</em>
              </article>
            ))}
          </div>
        ) : (
          <p className="setup-empty">Les recherches du tableau s’affichent ici.</p>
        )}
      </section>

      <section aria-label="Graphiques">
        <h3>Graphiques</h3>
        {charts.length ? (
          <div className="setup-board__tiles">
            {charts.map((item) => (
              <article
                key={item.id}
                data-setup-id={item.id}
                className={`setup-chart${setupOn(item.id, beat)}`}
              >
                <ChartGlyph type={item.chartType} />
                <span>{item.name}</span>
                <em>{CHART_KIND[item.chartType] || 'Graphique'} · {FIELD_KIND[item.field] || item.field}</em>
              </article>
            ))}
          </div>
        ) : (
          <p className="setup-empty">Les graphiques s’affichent ici.</p>
        )}
      </section>
    </div>
  );
};

export default SetupBoard;
